import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  UPLOAD_AUTH_FILES_REQUEST: '',
  UPLOAD_AUTH_FILES_SUCCESS: '',
  UPLOAD_AUTH_FILES_FAILURE: '',

  GET_SUBMITTED_FILE_NAMES_REQUEST: '',
  GET_SUBMITTED_FILE_NAMES_SUCCESS: '',
  GET_SUBMITTED_FILE_NAMES_FAILURE: '',

  GET_ALL_FILES_BY_TAGS_REQUEST: '',
  GET_ALL_FILES_BY_TAGS_SUCCESS: '',
  GET_ALL_FILES_BY_TAGS_FAILURE: '',

  DOWNLOAD_AUTH_FILE_REQUEST: '',
  DOWNLOAD_AUTH_FILE_SUCCESS: '',
  DOWNLOAD_AUTH_FILE_FAILURE: '',

  DOWNLOAD_FILE_BLOB_REQUEST: '',
  DOWNLOAD_FILE_BLOB_SUCCESS: '',
  DOWNLOAD_FILE_BLOB_FAILURE: '',

};

types = setStoreTypeValues(types, 'authFiles');

export default types;
